<template lang="pug">
  v-btn(
    color="primary"
    @click="candidatesZoomAllRegistrant"
    :disabled="disabled"
    outlined
    small
  ) Send all to Zoom
</template>

<script>
import errorsMixin from '@/mixins/errors.mixin';
import apiCourses from '@/services/api/api-courses';
import courseService from '@/app/admin/models/courseService.js';

export default {
  mixins: [errorsMixin],

  props: {
    disabled: Boolean,
    courseID: Number
  },

  data: () => ({
    actionsService: new courseService(apiCourses)
  }),

  methods: {
    async candidatesZoomAllRegistrant() {
      try {
        let res = await this.actionsService.candidatesZoomAllRegistrantBulk(this.courseID)
        this.$notify({text: 'Setting all candidates zoom presentie', type: 'success'})
      } catch (err) {
        this.processError(err)
      }
    }
  },
}
</script>
